<template >

<BeamerUnsupportedFeatures v-if="!showPresentationlayoutStudio && !isFinal" />

<v-container fluid>
  <v-row>
    <v-col cols="8" offset="2">
      <!-- Show the view of tree file view -->
      <TreeFileView v-motion-fade v-if="selectedZip && showPresentationlayoutStudio && !isFinal" :zipFile="selectedZip" />
      <!-- Show the final preview of the presentation layout studio -->
      <FinalPreview v-motion-fade v-if="finalData" :finalData="finalData"  />
    </v-col>
    <v-col cols="2">
      <v-btn 
        class="ma-2 pa-2 elevation-5 font-weight-light" 
        v-if="showPresentationlayoutStudio || isFinal"
        v-motion-fade
        @click="
          showPresentationlayoutStudio = false;
          selectedZip = undefined;
          finalData = null;
          isFinal = false;">
          <v-icon start class="mr-2">mdi-arrow-left</v-icon>
        {{ isFinal ? 'Neues Zip hochladen' : 'Zurück' }}
      </v-btn>
    </v-col>
  </v-row>
</v-container>

    
<v-container v-if="!showPresentationlayoutStudio && !isFinal" fluid >
    <v-row>
      <v-col cols="10" offset="1">
        <v-sheet v-motion-pop-visible class="d-flex justify-center flex-column align-center bg-blue-grey-lighten-4">
          <div class="ma-2 pa-2 text-none ">
            <v-file-upload
              v-model="selectedZip" 
              clearable 
              density="default"
              color="blue-grey-lighten-3"
              label="Latex-Datei hochladen"
              divider-text="oder"
              browse-text="Zip hochladen"
              title="ziehen & droppen hierher"
              variant="outlined" 
              accept=".zip"
              elevation="5"
              show-size>
            </v-file-upload>
        </div>
        </v-sheet>
          <v-btn 
            v-motion-pop-visible
            v-if="selectedZip != null" 
            class="ma-2 pa-2 elevation-5 w-25 text-none bg-blue-grey-lighten-2" 
            @click="showPresentationlayoutStudio = true">
            Hochladen
          </v-btn>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    
  </v-container>

   <!-- Progress Icon for creating suggestions -->
   <div v-motion-fade v-if="showPresentationlayoutStudio && isLoading" class="d-flex justify-center align-center flex-column" style="height: 50vh;">
        <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="blue-grey-darken-1"
        >
        <v-icon class="mr-2" size="x-large">mdi-cogs</v-icon>
        </v-progress-circular>

        <p v-if="isLoading" 
           class="mt-10 text-h6 text-center">
           Ladevorgang läuft... 
        </p> 
    </div>

<!-- Show the view of presentation layout studio -->
<SlideStudioView 
   v-motion-fade
  v-if="selectedZip && showPresentationlayoutStudio" 
  :zip="selectedZip" 
  @isLoading="isLoadingHandling"
  @finalPreview="finalPreviewHandling"
  />


</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SlideStudioView from './components/SlideStudioView.vue';
import TreeFileView from './components/TreeFileView.vue';
import FinalPreview from './components/FinalPreview.vue';
import BeamerUnsupportedFeatures from './components/BeamerUnsupportedFeatures.vue';
import { FinalData } from '@/types/finaldata';

export default defineComponent({
    name: 'MainView-Componenten',
    components: {
      SlideStudioView,
      TreeFileView,
      FinalPreview,
      BeamerUnsupportedFeatures
    },
    data() {
        return {
            selectedZip: undefined as File | undefined,
            shouldSwitch: false as boolean,
            showPresentationlayoutStudio: false as boolean,
            files: [],
            isLoading: false as boolean,
            finalData: null as FinalData | null,
            isFinal: false as boolean,
        };
    },
    methods: {
      isLoadingHandling(isLoading: boolean){
        this.isLoading = isLoading;
      },
      finalPreviewHandling(finalData: FinalData){
        if( finalData.finalFile && finalData.finalFile){
          this.finalData = finalData;
          this.selectedZip = undefined;
          this.showPresentationlayoutStudio = false;
          this.isFinal = true;
          this.isLoading = false;
        }
      },
    },
    created() {
    },
});
</script>
